import { useState } from 'react';
import { IRecomendVideo, VideoCard } from '../model/home';
import { subjectColors } from '../consts/subject';
import { Button } from './ui/button';
import { CommonVideoCard } from './homepage/CommonVideoCard';

const RecommendedClipsGrid = (props: {
  videos: VideoCard[];
  onVideoClick: (videoId: string) => void;
}) => {
  const recommendedVideosList: IRecomendVideo[] = props.videos.map((rv) => ({
    id: rv.video_id,
    question: rv.title,
    subject: rv.subject,
    views: '1.2k',
    likes: 200,
    cover_img: rv.cover_img,
    video_url: rv.video_url,
    createdAt: new Date(rv.create_ts * 1000),
    video_duration: rv.video_duration,
  }));
  const [visibleCount, setVisibleCount] = useState(8);

  const handleLoadMore = () => {
    setVisibleCount((prev) => Math.min(prev + 8, recommendedVideosList.length));
  };

  // const visibleVideos:IRecomendVideo[] = recommendedVideosList.slice(0, visibleCount);
  const hasMore = false;

  return (
    <>
      <div className="pb-6">
        <div className="flex flex-wrap">
          {(recommendedVideosList || []).map((video, index) => (
            <CommonVideoCard
              key={video.id}
              video={video}
              index={index}
              subjectColorMap={subjectColors}
              onVideoClick={props.onVideoClick}
            />
          ))}
        </div>
      </div>

      {hasMore && (
        <div className="flex justify-center mt-8">
          <Button
            onClick={handleLoadMore}
            variant="outline"
            className="px-8 py-6 rounded-full bg-white hover:bg-primary/10 border-2 border-black/10 hover:border-primary transition-all hover:scale-105"
          >
            Load More
          </Button>
        </div>
      )}
    </>
  );
};

export default RecommendedClipsGrid;
